import React, { useState } from 'react';
import { faqs } from '../data/mock';
import { ChevronDown } from 'lucide-react';

const FAQItem = ({ f, i }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="gradient-border px-6 border-b-0">
      <button
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between py-5 text-left text-white text-base md:text-lg font-semibold"
      >
        {f.q}
        <ChevronDown
          className={`w-5 h-5 text-white/50 flex-shrink-0 ml-4 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <div className="text-white/65 text-sm md:text-base leading-relaxed pb-5">
          {f.a}
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  return (
    <section id="faq" className="relative py-20 md:py-28 overflow-hidden">
      <div className="max-w-3xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <p className="text-blue-400 text-sm font-semibold uppercase tracking-widest mb-3">Precisa de ajuda?</p>
          <h2 className="text-4xl md:text-6xl font-extrabold text-white leading-tight">
            Perguntas Frequentes
          </h2>
        </div>
        <div className="space-y-3">
          {faqs.map((f, i) => <FAQItem key={i} f={f} i={i} />)}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
